import {Pipe, PipeTransform} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@Pipe({
    name: 'replace',
    standalone: false
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, replace: string, withValue: Observable<string> | string): Observable<string> {
    if (withValue !== undefined) {
      if (typeof withValue === 'string') {
        return of(value.replace(replace, withValue));
      } else {
        return withValue.pipe(
          map((scalarWithValue) => value.replace(replace, scalarWithValue)),
        );
      }
    }
  }
}
